export default __webpack_public_path__ + "static/Card32-d6983f0d3f666d28c568f706ca294a18.png";